import styled from 'styled-components';

export const ResumeSection = styled.section`
    width: 100%;
    height: 100%;
`;